// const jQuery = require( "jquery" );
import "../styles/app.scss";
import "../node_modules/@splidejs/splide/dist/css/splide.min.css";
import "../node_modules/vanillajs-datepicker/dist/css/datepicker.css";

import Splide from "@splidejs/splide";

import { toggle } from "./toggle/toggle.js";
import { cookiePolicy } from "./cookiepolicy/cookiepolicy.js";
import { multilevel } from "./multilevel-nav/multilevel-nav.js";
import { windowheight } from "./windowheight/windowheight.js";
import dynamicSrc from "./dynamic-src/dynamic-src";
import lib from "./lib/lib";
import { sliderLightbox } from "./slider-lightbox";

sliderLightbox.init();

// import { scrollanimation } from "./scrollanimation/scrollanimation";
var elemental = require("./elem/elem.js");

// let CookiesEuBanner = new cookiePolicy();

let Multilevel = new multilevel(".menu");

// let ScrollAnimation = new scrollanimation();

// Replace wistia video for mobile
if (lib.qs(".atom-video-wistia")) {
  const desktopID = lib.qs(".wistia_embed").getAttribute("data-desktop-src");
  const mobileID = lib.qs(".wistia_embed").getAttribute("data-mobile-src");

  window._wq = window._wq || [];

  _wq.push({
    id: desktopID,
    options: {
      autoPlay: true,
    },
    onReady: function (video) {
      if (lib.windowWidth() <= 600) {
        video.replaceWith(mobileID);
      }
    },
  });
}

// Extend MultiLevel Nav with a back button

let backBtn = document.querySelectorAll(".close-active-menu");

backBtn.forEach(function (child) {
  child.addEventListener("click", function () {
    let menuActive = document.querySelectorAll(
      ".menu-active, .parent-menu-active"
    );

    menuActive.forEach(function (childx) {
      childx.classList.remove("menu-active");
      childx.classList.remove("parent-menu-active");
    });
  });
});

let toggleNavicon = new toggle(
  "data-linknavicon",
  "data-targetnavicon",
  "active"
);

let toggleLanguage = new toggle(
  "data-linklanguage",
  "data-targetlanguage",
  "active-language"
);

let toggleBookNow = new toggle(
  "data-linkbooknow",
  "data-targetbooknow",
  "active-booknow"
);

let toggleLightbox = new toggle(
  "data-linklightbox",
  "data-targetlightbox",
  "active-lightbox"
);

let toggleVideoLightbox = new toggle(
  "data-linkvideolightbox",
  "data-targetvideolightbox",
  "active-videolightbox"
);

// document.querySelectorAll('.pop-up-target .close-button').forEach(function (child) {
//   child.addEventListener('click', () => {
//     console.log('clicked');
//       child.parentNode.classList.remove('active-lightbox');
//   })
// });

function inheritLinks() {
  var inheritLinks = document.querySelectorAll(
    ".inherit-link, .bounce-inherit-link"
  );

  let i;
  inheritLinks.forEach(function (links) {
    if (!links.classList.contains("disable__link")) {
      // Search for parent node

      if (links.classList.contains("bounce-inherit-link")) {
        links = links.parentNode;
      }

      // Loop around click event, get ref and redirect window
      links.addEventListener("click", function () {
        let getLink = links.querySelector("a");

        // Identify _blank
        if (getLink.getAttribute("target") === "_blank") {
          window.open(getLink.href, "_blank");
        } else {
          window.location.href = getLink.href;
        }
      });
    }
  });
}

inheritLinks();

let WindowHeight = new windowheight();

//let animateScroll = new scrollanimation('.detect-scroll-pos');

export function main() {
  return console.log("Javascript Started");
}

let splideinit = [];

document.querySelectorAll(".splide-medium").forEach((splideelem, i) => {
  splideinit[i] = new Splide(splideelem, {
    type: "loop",
    perPage: 2,
    gap: "1.875vw",
    breakpoints: {
      580: {
        perPage: 1,
      },
    },
  });

  splideinit[i].on("mounted", function () {
    // if fewer slides than provided in options, set option to the number of slides
    if (splideinit[i].length <= splideinit[i].options.perPage) {
      //splideinit[i].options.perPage = splideinit[i].length;
      // splideinit[i].options.destroy = true;

      splideinit[i].destroy();
      splideelem.classList.add("destroyed");
    }
  });

  splideinit[i].mount();

  if (splideelem.classList.contains("slider-style-min")) {
    splideelem.querySelector(".splide__list").style.transform =
      "translateX(0px)";
  }
});

window.app = {
  splide: [],
};

document.querySelectorAll(".splide-large").forEach((elem, i) => {
  app.splide[i] = new Splide(elem, {
    type: "loop",
    perPage: 1,
    breakpoints: {
      580: {
        perPage: 1,
      },
    },
  }).mount();
});

// Detect scroll from top of the screen based on scroll distance
// class="detect-scroll-pos" data-distance="100"
document.querySelectorAll(".detect-scroll").forEach((elem) => {
  document.addEventListener(
    "scroll",
    () => {
      window.scrollY - elem.scrollTop > elem.dataset.distance
        ? elem.classList.add("detect-scroll-pos")
        : elem.classList.remove("detect-scroll-pos");
    },
    { passive: false }
  );
});

let accordian = document.querySelectorAll(".accordian");

// Accordian Script for the accordian
accordian.forEach((elem) => {
  // Loop through all accordians
  let accordianHeaders = elem.querySelectorAll(".accordian-header");
  let accordianContents = elem.querySelectorAll(".accordian-content");

  accordianHeaders.forEach((header) => {
    // Loop through all accordian headers
    header.addEventListener("click", (elem) => {
      // Add click event listener to each header

      // Toggle the accordian content
      if (header.classList.contains("active")) {
        header.classList.remove("active");
      } else {
        accordianHeaders.forEach((header) => {
          // Loop through all accordian headers
          header.classList.remove("active");
        });

        header.classList.add("active");
      }

      // accordianContents[accordianHeaders.indexOf(header)].classList.toggle('active');
    });
  });
});

// Add class to every other seperator block (Not the first) [CN]
[
  ...document.querySelectorAll(".separator-block .inner, .gfield.gsection"),
].every((elem, i) => {
  i > 0 ? elem.classList.add("active") : "";
  return true;
});
let measurableBlock = document.getElementById("filter-and-comparison-block");

// Add class to element when scroll point hits the top of the page [CN]
[...document.querySelectorAll(".is_top")].forEach((elem) => {
  elem.style.height = elem.offsetHeight + "px";
  window.addEventListener("scroll", () => {
    (
      Math.abs(elem.getBoundingClientRect().top) >
      measurableBlock.offsetHeight - 200
        ? true
        : false
    )
      ? elem.classList.remove("active")
      : (elem.getBoundingClientRect().top < 100 ? true : false)
      ? elem.classList.add("active")
      : elem.classList.remove("active");
  });
});

// The Reverie Boutique Popup Form Functionality
let popupFormBtn = document.querySelectorAll('a[href="#popupboutiqueform"'); // Select all reverie pop-up form buttons
popupFormBtn.forEach((elem) => {
  // Loop through all reverie pop-up form buttons

  // Initiate Form Popup Window
  let boutiqueform = document.querySelector(".boutique-product-form");
  let boutiqueoverlay = document.querySelectorAll(
    ".boutique-product-form .overlay, .boutique-product-form .close-icon"
  );

  boutiqueoverlay.forEach((elem) => {
    elem.addEventListener("click", () => {
      boutiqueform.classList.remove("active");
    });
  });

  // Select fields to populate
  let productPriceFill = document.querySelector(".product-price-fill input");
  let productTitleFill = document.querySelector(".product-name-fill input");
  let productQuantityFill = document.querySelector(
    ".product-quantity-fill input"
  );

  elem.addEventListener("click", (e) => {
    // Add click event listener to each button

    boutiqueform.classList.add("active");

    e.preventDefault(); // Prevent default behaviour of the button
    e.stopImmediatePropagation();
    let productPrice = elem.parentNode.querySelector(".product-price"); // Get the product price
    let productTitle = elem.parentNode.querySelector(".fs-40"); // Get the product title and strip tags
    let productQuantity = elem.parentNode.querySelector(".iscounter").value; // Get product QTY value
    let productTitleItalics = elem.parentNode.querySelector(".fs-40 em");
    // Poplulate Fields
    productPriceFill.value = extract(productPrice);
    productTitleFill.value =
      extract(productTitle) + " " + extract(productTitleItalics);
    productQuantityFill.value = productQuantity;
  });
});

// strip html tags from string
function strip_tags(input, allowed) {
  allowed = (
    ((allowed || "") + "").toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []
  ).join(""); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
  var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
    commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
  return input.replace(commentsAndPhpTags, "").replace(tags, function ($0, $1) {
    return allowed.indexOf("<" + $1.toLowerCase() + ">") > -1 ? $0 : "";
  });
}

// Extract Text
const extract = (node) => {
  const text = [...node.childNodes].find(
    (child) => child.nodeType === Node.TEXT_NODE
  );
  return text && text.textContent.trim();
};

document.querySelectorAll("a").forEach((elem) => {
  let searchLink = elem.href.indexOf("js-book-now");

  if (searchLink !== -1) {
    elem.addEventListener("click", (e) => {
      // Stop evvent and propergation on bottom
      e.preventDefault();
      e.stopImmediatePropagation();

      // Select the Book Now Partial
      let bookNowPartial = document.querySelector(".book-now-partial");
      let bookNowOverlay = document.querySelector(".book-now-partial-overlay");
      let bookNowBtn = document.querySelector(".book-now");

      // Add the active state to the book now partial
      bookNowPartial.classList.add("active-booknow");
      bookNowOverlay.classList.add("active-booknow");
      bookNowBtn.classList.add("active-booknow");
    });
  }
});

// Mall Map Tablet/Mobile Pin Event Click
if (document.querySelector(".pin-tag")) {
  let mapPins = document.querySelectorAll(".pin-tag");
  let tagsName = document.querySelectorAll(".tag-name");

  mapPins.forEach((mapPin) => {
    mapPin.addEventListener("click", () => {
      document.querySelectorAll(".pin-tag").forEach((elem) => {
        elem.classList.remove("active");
      });

      document.querySelectorAll(".tag-name").forEach((elem) => {
        elem.classList.remove("active");
      });

      document.querySelectorAll(".tag").forEach((elem) => {
        elem.classList.remove("active");
      });

      mapPin.classList.add("active");
      mapPin.nextSibling.classList.add("active");
      tagsName.forEach((tagName) => {
        tagName.classList.add("active");
      });
    });
  });
}

//POPUP WIDGET
if (document.querySelector(".popup-widget-wrapper")) {
  let popupWidget = document.querySelector(".popup-widget-wrapper");
  // Check for popupWidget sessionStorage
  if (!sessionStorage.getItem("hidden")) {
    popupWidget.style.display = "block";
    document.body.classList.add("popup-widget-active");
  } else {
    popupWidget.style.display = "none";
  }
  // Popup Widget Controller
  if (document.querySelector("#close-popup-widget")) {
    // On closing the widget hide and setItem into sessionStorage
    document
      .querySelector("#close-popup-widget")
      .addEventListener("click", () => {
        popupWidget.style.display = "none";
        document.body.classList.remove("popup-widget-active");
        window.sessionStorage.setItem("hidden", popupWidget);
      });
  }
}

// Side Scrolling Container
// Gives the functionality to be able to scroll down, but it continue sideways
const scrollContainer = document.querySelector(".side-scrolling");
if (scrollContainer) {
  scrollContainer.addEventListener("wheel", (evt) => {
    scrollContainer.scrollLeft += evt.deltaY;
  });
}

const tsENewsletter1 = document.querySelectorAll(
  'a[href="#timessquarenewsletter"]'
);
const tsNewsletterForm = document.querySelector("#timessquarenewsletter");

tsENewsletter1.forEach((elem) => {
  elem.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (tsNewsletterForm.classList.contains("active")) {
      tsNewsletterForm.classList.remove("active");
    } else {
      tsNewsletterForm.classList.add("active");
    }
  });
});

if (tsNewsletterForm) {
  tsNewsletterForm.querySelector(".overlay").addEventListener("click", (e) => {
    tsNewsletterForm.classList.remove("active");
  });

  tsNewsletterForm.querySelector(".close").addEventListener("click", (e) => {
    tsNewsletterForm.classList.remove("active");
  });
}
